<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  Choose what question grid you would like?
                </h3>
              </div>
            </div>
            <div class="pure-u-1">
              <div>
                <button class="pure-button bigmi-wide-button bigmi-red-2-button" @click="on4Click()">
                  <Fai v-if="isModel4Loading" :icon="['far', 'circle-notch']" spin/>
                  <span v-else>{{model4}}</span>
                </button>
              </div>
              <div class="use-6-6-row">
                <button class="pure-button bigmi-wide-button bigmi-red-2-button" @click="on6Click()">
                  <Fai v-if="isModel6Loading" :icon="['far', 'circle-notch']" spin/>
                  <span v-else>{{model6}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    GET_IN_PROGRESS_STUDY_MODEL,
    SET_IN_PROGRESS_STUDY_MODE,
    UPDATE_STUDY,
    STUDY_MODE_4,
    STUDY_MODE_6,
    LOADING_STARTED,
    GET_IS_IN_PROGRESS_STUDY_UPDATING,
  } from '../../services/constants'

  export default {
    name: 'ChooseNumberOfQuestions',
    data() {
      return {}
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
        GET_IN_PROGRESS_STUDY_MODEL,
        GET_IS_IN_PROGRESS_STUDY_UPDATING,
      ]),
      routeNextStep() {
        return this[GET_NEXT_STUDY_STEP_ROUTE]
      },
      model4() {
        return STUDY_MODE_4
      },
      model6() {
        return STUDY_MODE_6
      },
      studyMode() {
        return this.$store.state.dataModule.inProgressStudy.meta.gridMode
      },
      isModel4Loading() {
        return this[GET_IS_IN_PROGRESS_STUDY_UPDATING] && this.studyMode === STUDY_MODE_4
      },
      isModel6Loading() {
        return this[GET_IS_IN_PROGRESS_STUDY_UPDATING] && this.studyMode === STUDY_MODE_6
      },
    },
    methods: {
      on4Click() {
        this.$store.commit(SET_IN_PROGRESS_STUDY_MODE, STUDY_MODE_4)
        this.handleSubmit()
      },
      on6Click() {
        this.$store.commit(SET_IN_PROGRESS_STUDY_MODE, STUDY_MODE_6)
        this.handleSubmit()
      },
      handleSubmit() {
        this.$store.dispatch(UPDATE_STUDY).then(() => {
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  h3 {
    color: $cyan-blue-3;
  }

  .use-6-6-row {
    margin: 2em 0 0 0;
  }

</style>
